import PropTypes from "prop-types";
import { LISTER_USER_ROLE, SEEKER_USER_ROLE } from "datamodel/User/constants";

export const userRolePropTypes = PropTypes.oneOf([
  LISTER_USER_ROLE,
  SEEKER_USER_ROLE,
]);
